import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { Container, Button, DialogActions, DialogContent, DialogTitle, TextField   } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, CUPONESLISTAR, CUPONESACTUALIZAR, CUPONESAGREGAR } from '../services/apiConfig';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import Cargando from './utils/Cargando.jsx';
import { format, parse } from 'date-fns';
import esLocale from 'date-fns/locale/es';
import '../App.css'; // Importa tu archivo de estilos
import DatePicker from 'react-datepicker'; //https://reactdatepicker.com/
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerStyles.css'; // Importa tus estilos personalizados
import * as XLSX from 'xlsx';
import { IconButton } from '@mui/material';
import { SaveAlt } from '@mui/icons-material';

function CuponesList() {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(''); // Agrega esta línea
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
 

  const [isPorcentajeDescuento, setIsPorcentajeDescuento] = useState(true); // Nuevo estado para el tipo de descuento
  const [FechaValidezHasta, setFechaValidezHasta] = useState('');
  const [CuponNombre, setCuponNombre] = useState('');
  const [CuponCodigo, setCuponCodigo] = useState('');
  const [Cupondescuento, setCupondescuento] = useState('');
  const [CuponCantidad, setCuponCantidad] = useState('');
  const [CuponTope, setCuponTope] = useState('');
  const [CuponActivo, setCuponActivo] = useState(true);
  
  const fechaHoy = new Date();


 
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'nombre', headerName: 'Nombre', width: 200 },
    { field: 'codigo', headerName: 'Codigo', width: 200 },
    {
      field: 'fechavalidezhasta',
      headerName: 'Fecha validez hasta',
      width: 150,
      cellClassName: 'dateField',
      renderCell: (params) => (
        <div>
          {params.value ? format(parse(params.value, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy') : ''}
        </div>
      ),
    },
    
    { field: 'cantidad', headerName: 'Cantidad', width: 90 }, 
    { field: 'es_porcentaje', headerName: '%', width: 80,  cellClassName: (params) => (params.value ? 'boolFieldTrue' : 'boolFieldFalse'),
    renderCell: (params) => (<div>{params.value ? 'Sí' : 'No'}</div>), },
    { field: 'descuento', headerName: 'Descuento', width: 130 }, 
    { field: 'tope', headerName: 'Tope', width: 100 }, 
    //descuento
    { field: 'activo', headerName: 'Activo', width: 80,  cellClassName: (params) => (params.value ? 'boolFieldTrue' : 'boolFieldFalse'),
      renderCell: (params) => (<div>{params.value ? 'Sí' : 'No'}</div>), },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      renderCell: (params) => (
        <div>
          <Button onClick={() => handleEdit(params.row)}>Modificar</Button>

      </div>
      ),
    },
  ];


  useEffect(() => {
   // console.log('paso por useEffect');
    /*const loggedIn = sessionStorage.getItem("loggedIn");
    if (!loggedIn) {
      navigate("/login");
    }
*/
    fetchCupones(); // Llamada a la función para cargar las sucursales

  }, []);

  const handleEdit = (user) => {
    setErrorMessage('');
    setSelectedUser(user);
   // Parsear la fecha original a un objeto de fecha
    const fechaFormateadaParaDateTimePicker = parse(user.fechavalidezhasta, 'yyyy-MM-dd', new Date());
    // Formatear la fecha en el formato deseado (por ejemplo, Fri Mar 15 2024 10:56:36 GMT-0300)
    //const fechaFinal = format(fechaFormateadaParaDateTimePicker, 'EEE MMM dd yyyy HH:mm:ss zzz');

    setFechaValidezHasta(fechaFormateadaParaDateTimePicker);
    setCuponNombre(user.nombre || '')
    setCuponCodigo(user.codigo || '');
    setCuponCantidad(user.cantidad || '');
    setCupondescuento(user.descuento || '');
    setIsPorcentajeDescuento(user.es_porcentaje);
    setCuponActivo(user.activo);
    setCuponTope(user.tope || 0);
    setIsEditDialogOpen(true);
  };

const handleAddCupon = () => {
  setSelectedUser(null); // Resetea el usuario seleccionado
  setCuponNombre('');
  setCuponCodigo('');
  setCuponCantidad('');
  setCupondescuento('');
  setCuponTope('');
  setFechaValidezHasta(null);
  setIsEditDialogOpen(true);
};



  const handleSave = (selectedUser) => {

    if (CuponNombre === null || CuponNombre === undefined) { 
      setErrorMessage('Por favor, completa el nombre.');
      return;
    }

    if (CuponCodigo === null || CuponCodigo === undefined) { 
      setErrorMessage('Por favor, completa el Codigo del cupon.');
      return;
    }

    
    if (FechaValidezHasta === null || FechaValidezHasta === undefined) {
      setErrorMessage('Por favor, completa la fecha de validez hasta del cupón.');
      return;
    }
    
    

    const cantidad = parseInt(CuponCantidad);
    if (Number.isNaN(cantidad) || !Number.isInteger(cantidad)) {
      setErrorMessage('Por favor, ingresa una cantidad válida como número entero.');
      return;
    }

    if(isPorcentajeDescuento===1 || isPorcentajeDescuento === true)
      {
        const descuento = parseInt(Cupondescuento, 10);
        if (isNaN(descuento) || !Number.isInteger(descuento) || descuento <= 0 || descuento >= 99) {
          setErrorMessage('Por favor, ingresa un porcentaje de descuento válido como número entero entre 1 y 99.');
          return;
        }
      }

      
    const tope = parseInt(CuponTope);
    if (Number.isNaN(tope) || !Number.isInteger(tope)) {
      setErrorMessage('Por favor, ingrese un tope valido.');
      return;
    }


var fechaValidezHasta = FechaValidezHasta ? format(new Date(FechaValidezHasta), 'yyyy-MM-dd') : null;


const updatedUserData = {
  id: (selectedUser === null ? 0 : selectedUser.id), 
  fechavalidezhasta: fechaValidezHasta,
  cantidad : CuponCantidad,
  nombre : CuponNombre,
  descuento : Cupondescuento,
  codigo: CuponCodigo,
  esPorcentaje: isPorcentajeDescuento,
  tope : CuponTope,
  activo : CuponActivo
};

    axios.post(API_BASE_URL + (selectedUser === null ? CUPONESAGREGAR : CUPONESACTUALIZAR), updatedUserData)
    .then((response) => {
    console.log(response.status);
    if (response.status === 200) {
      
      fetchCupones(); // Llamada a la función para cargar los cupones

      setIsEditDialogOpen(false);
    } else {
      setErrorMessage('Error al guardar los datos. Código de estado: ' + response.status);
    }
  })
  .catch((error) => {
    setErrorMessage('Error al realizar la solicitud: ' + error.message);
  });

    // Limpiar el mensaje de error si la validación es exitosa
    setErrorMessage('');
    setIsEditDialogOpen(false);
  };

  const fetchCupones = () => {
    axios.get(API_BASE_URL + CUPONESLISTAR)
      .then((response) => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error al cargar los cupones', error);
        setLoading(false);
      });
  };


  const exportToExcel = () => {
    const fileName = 'cupones.xlsx';
    const data = users.map(user => ({
      ID: user.id,
      Nombre: user.nombre,
      Codigo: user.codigo,
      'Fecha validez hasta': user.fechavalidezhasta ? format(parse(user.fechavalidezhasta, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy') : '',
      Cantidad: user.cantidad,
      '%': user.es_porcentaje ? 'Sí' : 'No',
      Descuento: user.descuento,
      Activo: user.activo ? 'Sí' : 'No',
    }));
  
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cupones');
    XLSX.writeFile(wb, fileName);
  };


  return (
    <div>
      <Container>
        <MenuInicial></MenuInicial>
        <div className='miDiv'><h2>Cupones</h2></div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <Button onClick={() => handleAddCupon()} variant="contained" color="primary">
              Agregar Cupón
            </Button>
          </div>
          <div>
            <IconButton onClick={exportToExcel} color="success">
              <SaveAlt />
            </IconButton>
          </div>
        </div>
        <div>
          {loading ? (
            <Cargando></Cargando>
          ) : (
              <DataGrid rows={users} columns={columns} />
            )}
        </div>
      </Container>
      <div>
        <Dialog open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)}>
          <DialogTitle> {selectedUser ? `Editar Cupon ${CuponNombre}` : 'Nuevo Cupon '}</DialogTitle>
          <DialogContent>
            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <TextField
                label="Nombre"
                type="text"
                value={CuponNombre}
                onChange={(e) => setCuponNombre(e.target.value)}
              />
            </div>
            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <TextField
                label="Codigo"
                type="text"
                value={CuponCodigo}
                onChange={(e) => setCuponCodigo(e.target.value)}
              />
            </div>
            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <DatePicker
                selected={FechaValidezHasta}
                onChange={date => setFechaValidezHasta(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="Fecha validez hasta"
                locale={esLocale}
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={5}
                showMonthDropdown
                scrollableMonthYearDropdown
                dropdownMode="select"
                isClearable={true}
                className="custom-datepicker" // Clase para tus estilos personalizados
                minDate={fechaHoy} // Desactiva fechas posteriores a hoy
              />
            </div>

            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <TextField
                label="Cantidad"
                type="text"
                value={CuponCantidad}
                onChange={(e) => setCuponCantidad(e.target.value)}
                
              />
            </div>

            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <div> <label>es %</label>
                <input
                  type="checkbox"
                  
                  checked={isPorcentajeDescuento}
                  onChange={(e) => setIsPorcentajeDescuento(e.target.checked)}
                  label="Checkear si es porcentaje de descuento"
                />
              </div>
              <TextField
                label={isPorcentajeDescuento ? "porcentaje":"importe en $"}
                type="text"
                value={Cupondescuento}
                onChange={(e) => setCupondescuento(e.target.value)}
              />
            </div>

            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <TextField
                label="Tope"
                type="text"
                value={CuponTope}
                onChange={(e) => setCuponTope(e.target.value)}
                
              />
            </div>

            
            <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
              <div> <label>Activo</label>
                <input
                  type="checkbox"
                  
                  checked={CuponActivo}
                  onChange={(e) => setCuponActivo(e.target.checked)}
                  label="Acivo"
                />
              </div>
              </div>
            {errorMessage && (
              <div style={{ color: 'red', marginTop: '10px' }}>
                {errorMessage}
              </div>
            )}
          </DialogContent>
          <div className='miDiv'>
            <DialogActions>
              <Button variant="contained" onClick={() => setIsEditDialogOpen(false)} color="error">
                Cancelar
              </Button>
              <Button variant="contained" onClick={() => selectedUser ? handleSave(selectedUser) : handleSave(null)} color="primary">
                Guardar
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default CuponesList;
